// ReasonScopeSelector — "Apply this reason to" radio pair shown under the bulk
// reason field when ≥1 resource requires a reason. Chooses whether the bulk
// reason is sent to only the required resources (default) or all of them.

import { Box } from "@chakra-ui/react";
import Radio, { RadioGroup } from "components/ds/Radio";
import { pluralise } from "modules/utils";

export interface ReasonScopeSelectorProps {
  onlyRequired: boolean;
  onChange: (onlyRequired: boolean) => void;
  /** How many submittable resources require a reason. */
  requiredCount: number;
  totalCount: number;
}

const ReasonScopeSelector = ({
  onlyRequired,
  onChange,
  requiredCount,
  totalCount,
}: ReasonScopeSelectorProps) => (
  <Box display="flex" flexDirection="column" gap="2xs" mt="sm">
    <Box fontSize="xs" fontWeight={600} color="neutral.700">
      Apply this reason to
    </Box>
    <RadioGroup aria-label="Apply this reason to">
      <Radio checked={onlyRequired} onChange={() => onChange(true)}>
        Only the {requiredCount} {pluralise("resource", requiredCount)} that
        require it
      </Radio>
      <Radio checked={!onlyRequired} onChange={() => onChange(false)}>
        All {totalCount} {pluralise("resource", totalCount)} in this request
      </Radio>
    </RadioGroup>
  </Box>
);

export default ReasonScopeSelector;
